import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=7442de81&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442de81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7442de81')) {
      api.createRecord('7442de81', component.options)
    } else {
      api.reload('7442de81', component.options)
    }
    module.hot.accept("./CustomerModal.vue?vue&type=template&id=7442de81&scoped=true", function () {
      api.rerender('7442de81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/CustomerModal.vue"
export default component.exports